import { useState } from 'react';
import { Copy, Task } from '@carbon/react/icons';
import { Button } from '@carbon/react';

export function CopyButton({
  node,
  className,
}: {
  node: string | number | boolean;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const copyHandler: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation();

    const value = typeof node === 'string' ? node.replace('"', '') : node;

    if (value) {
      navigator.clipboard.writeText(String(value));
    }

    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return copied ? (
    <Button
      size="sm"
      hasIconOnly
      kind={'ghost'}
      iconDescription={'Copied!'}
      tooltipAlignment="center"
      tooltipPosition="top"
      renderIcon={Task}
      className={className}
    />
  ) : (
    <Button
      size="sm"
      hasIconOnly
      kind={'ghost'}
      iconDescription={'Copy text'}
      tooltipAlignment="center"
      tooltipPosition="top"
      renderIcon={Copy}
      onClick={copyHandler}
      className={className}
    />
  );
}
